export default __webpack_public_path__ + "static/media/Add.ad790931.svg";